window.addEventListener("load", fancyTestimonial);
function fancyTestimonial() {
  if (!document.querySelector(".jgw-fancy-slider__wrapper")) {
    return null;
  }
  //setup
  activate();

  const nextBtns = [
    ...document.querySelectorAll(
      ".go-to-next, [data-queue='next'] .person-image__container"
    )
  ];

  const prevBtns = [
    ...document.querySelectorAll(
      ".go-to-prev, [data-queue='previous'] .person-image__container "
    )
  ];

  nextBtns.forEach(nextBtn => {
    nextBtn.addEventListener("click", e => {
      activate("next");
    });
  });
  prevBtns.forEach(prevBtn => {
    prevBtn.addEventListener("click", () => activate("prev"));
  });
}

//sets prev and next siblings to proper data attr
function setsAttributes(activeEl) {
  [...activeEl.parentElement.querySelectorAll("[data-show]")].forEach(el => {
    el.removeAttribute("data-queue");
  });

  activeEl.dataset.queue = "current";
  console.log(activeEl.dataset.queue);
  if (activeEl.nextElementSibling) {
    activeEl.nextElementSibling.dataset.queue = "next";
  } else {
    activeEl.parentElement.firstElementChild.dataset.queue = "next";
  }
  if (activeEl.previousElementSibling) {
    activeEl.previousElementSibling.dataset.queue = "previous";
  } else {
    activeEl.parentElement.lastElementChild.dataset.queue = "previous";
  }
}

function activate(dir) {
  const currentStateEl = document.querySelector(".jgw-fancy-slider");
  const currentState = currentStateEl.dataset.personstate;
  //creates number from the current state
  const currentStateParsed = parseInt(currentState.split("-")[1]);

  //going to add or subtract based on the direction that was clicked
  const direction = dir === undefined ? 0 : dir === "next" ? +1 : -1;

  //this finds out if needs to loop back around
  const newStateParsed = list => {
    if (direction + currentStateParsed <= 0) {
      return list.length;
    } else if (direction + currentStateParsed > list.length) {
      return 1;
    } else {
      return direction + currentStateParsed;
    }
  };
  //this is the list we are looping through
  const testimonyList = [...document.querySelectorAll(".testimony")];

  //sets the new state value
  const stateValue = `person-${newStateParsed(testimonyList)}`;

  //this is the reaction to the new state
  [...document.querySelectorAll("[data-active]")].forEach(el => {
    el.removeAttribute("data-active");
  });

  [
    ...document.querySelectorAll(
      `[data-show~="${stateValue}"], [data-hide]:not([data-hide~="${stateValue}"])`
    )
  ].forEach(el => {
    el.setAttribute("data-active", true);
  });
  const activeElments = [...document.querySelectorAll("[data-active]")];
  activeElments.forEach(el => {
    setsAttributes(el);
  });
  currentStateEl.dataset.personstate = stateValue;
}
